import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import { GetAllDesktopSettingsResponse } from './getAllDesktopSettings.types'

export const getAllDesktopSettings = async () => {
  const response = await containerApi.get<GetAllDesktopSettingsResponse>(
    '/desktop/all',
    {
      params: { wallpaper_animation: 'preview' }
    }
  )
  return response.data.data
}

export const GET_ALL_DESKTOP_SETTINGS_QUERY_KEY = 'getAllDesktopSettings'

export const useGetAllDesktopSettingsQuery = (
  options?: ExtendableQueryOptions<GetAllDesktopSettingsResponse['data']>
) => {
  return useQuery({
    queryKey: [GET_ALL_DESKTOP_SETTINGS_QUERY_KEY],
    queryFn: getAllDesktopSettings,
    ...options
  })
}
